import { Permissions } from '@components/PermissionsGuard/PermissionsGuard'

export const user = {
	userPreferences: [
		{
			id: 0,
			key: 'reportsCombinePersonalized',
			value: 'false',
		},
		{
			id: 1,
			key: 'reportsOnlyFavorites',
			value: 'true',
		},
	],
}

export const users = [
	{
		id: '1',
		status: 'active',
		enabled: true,
		firstName: 'John',
		lastName: 'Doe',
		displayName: 'John Doe',
		email: 'john.doe@example.com',
		profilePic: '',
		roles: ['BI Admin', 'BI Analyst'],
		permissions: ['bi-manage-users', 'market-basket-editor'],
		superAdmin: false,
	},
	{
		id: '2',
		status: 'invited',
		enabled: false,
		firstName: 'Jane',
		lastName: 'Smith',
		displayName: 'Jane Smith',
		email: 'jane.smith@example.com',
		profilePic: '',
		roles: ['BI Analyst'],
		permissions: ['bi-manage-users', 'market-basket-editor'],
		superAdmin: false,
	},
	{
		id: '3',
		status: 'active',
		enabled: true,
		firstName: 'Alice',
		lastName: 'Johnson',
		displayName: 'Alice Johnson',
		email: 'alice.johnson@example.com',
		profilePic: '',
		roles: ['BI Admin', 'BI Analyst'],
		permissions: ['bi-manage-users', 'market-basket-editor'],
		superAdmin: false,
	},
	{
		id: '4',
		status: 'invited',
		enabled: true,
		firstName: 'Bob',
		lastName: 'Brown',
		displayName: 'Bob Brown',
		email: 'bob.brown@example.com',
		profilePic: '',
		roles: ['BI Analyst'],
		permissions: ['bi-manage-users', 'market-basket-editor'],
		superAdmin: false,
	},
	{
		id: '5',
		status: 'active',
		enabled: true,
		firstName: 'Charlie',
		lastName: 'Williams',
		displayName: 'Charlie Williams',
		email: 'charlie.williams@example.com',
		profilePic: '',
		roles: ['BI Analyst'],
		permissions: ['bi-manage-users', 'market-basket-editor'],
		superAdmin: false,
	},
]

export const userWithAllPermissions = {
	id: '99',
	status: 'active',
	enabled: true,
	firstName: 'Super',
	lastName: 'Admin',
	displayName: 'Super Admin',
	email: '',
	profilePic: '',
	roles: [
		{
			id: 99,
			name: 'SYS_ADMIN',
			displayName: 'System Admin',
			enabled: true,
			description: 'System administrator role',
			permissions: [],
		},
	],
	permissions: Object.values(Permissions),
	isSuperAdmin: false,
	unreadNotificationCount: 0,
	preferences: {},
}

export const me = {
	id: '2',
	firstName: 'Debra',
	lastName: 'Harry',
	displayName: 'Debra Harry',
	email: 'debra.harry@blondie.com',
	status: 'ACTIVE',
	enabled: true,
	roles: [
		{
			id: '2',
			name: 'BI_ANALYST',
			enabled: true,
			displayName: 'BI Analyst',
			description: 'Analyst role with access to edit market baskets',
			permissions: [
				{
					id: 5,
					name: 'BI_DASHBOARD_VIEW',
					description: 'View BI dashboard',
				},
				{
					id: 1,
					name: 'MARKET_BASKET_EDIT',
					description: 'Permission to edit market basket data',
				},
			],
		},
	],
	profilePic: '',
	lastLogin: '2026-01-13T21:04:46.161527Z',
	lastActive: '2026-01-13T21:04:46.164497Z',
	permissions: ['BI_DASHBOARD_VIEW', 'MARKET_BASKET_EDIT'],
	isSuperAdmin: true,
	unreadNotificationCount: 2,
	preferences: [
		{
			id: '856',
			key: 'purchaseColumnLayout',
			value: '2',
		},
		{
			id: '522',
			key: 'purchaseListColumns',
			value: '[{"field":"groupKeyDisplayName","visible":true},{"field":"packSize","visible":true}]',
		},
		{
			id: '580',
			key: 'showMyBaskets',
			value: 'false',
		},
		{
			id: '515',
			key: 'sidebarExpanded',
			value: 'false',
		},
	],
}
